module.exports = __webpack_public_path__ + "img/c22.46a50792.png";